<template>
  <b-card class="center_card" footer-class="my-footer">
    <b-card-title id="forgot" class="title-card-mdp mb-2">Mot de passe oublié ?</b-card-title>
    <div class="sub-title mb-3">
      Pour réinitialiser votre mot de passe, merci de renseigner l'email associé à votre compte Sivercoh.
    </div>
    <b-row no-gutters>
      <b-col>
        <b-form-group class="mt-2" label-class="font-weight-bold" label-size="lg" label-align="left">
          <b-input-group>
            <b-input-group-text variant="primary">
              <i class="fas fa-user"></i>
            </b-input-group-text>
            <Field name="email" type="email" placeholder="Email" class="form-control" />
          </b-input-group>
          <ErrorMessage name="email" class="text-danger" />
        </b-form-group>
      </b-col>
    </b-row>

    <p class="sub-title mb-2">Enregistrez le captcha:</p>
    <div class="form-row">
      <div class="form-group col-md-5" id="captcha"></div>
      <div class="form-group col-md-7">
        <input v-model="captchaInput" type="text" class="form-control" placeholder="Captcha" />
      </div>
    </div>


    <button type="submit" class="btn btn-connect m-2" @click.prevent = "sendMail">Valider</button>
    <router-link to="login" class="btn btn-cancel m-2">Annuler</router-link>
    <button type="button" class="btn btn-refresh" @click="createCaptcha">
      Captcha <i class="fas fa-sync"></i>
    </button>
    </b-card>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import http from '@/http';
import router from '@/router';

    const email = ref(null);
    const captchaCode = ref('');
    const captchaInput = ref('');

    const schema = yup.object({
      email: yup.string().email('Email invalide').required('Ce champ est obligatoire')
    });

    const { handleSubmit } = useForm({
      validationSchema: schema
    });

    const createCaptcha = () => {
      const charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const captchaLength = 6;
      let captcha = '';

      for (let i = 0; i < captchaLength; i++) {
        const index = Math.floor(Math.random() * charsArray.length);
        captcha += charsArray[index];
      }

      const canvas = document.createElement('canvas');
      canvas.width = 200;
      canvas.height = 50;
      const ctx = canvas.getContext('2d');
      ctx.font = '25px Georgia';
      ctx.strokeText(captcha, 0, 30);
      captchaCode.value = captcha;
      const captchaDiv = document.getElementById('captcha');
      captchaDiv.innerHTML = '';
      captchaDiv.appendChild(canvas);
    };

    const validateCaptcha = () => {
      return captchaInput.value === captchaCode.value;
    };

    const sendMail = handleSubmit(async (values) => {
      if (!validateCaptcha()) {
        alert("Veuillez entrer un captcha valide");
        return;
      }
      try {
        const data = await http.verifUserByEmail(values.email);
        if (data) {
          email.value = await http.forgotPassword(values.email);
          await router.push({name: 'Login'})
        }else {
          alert("L'adresse mail n'est pas reconnue");
        }
      } catch (error) {
        console.error("Erreur lors de l'envoi de l'email:", error);
      }
    });
    onMounted(createCaptcha);

</script>

<style scoped>

.center_card {
  margin: 13em auto;
  width: 40%;
  background-color: #00a3a6;
  color: #17a2b8;
  border: none;
}

.title-card-mdp {
  color: white;
}

.sub-title {
  color: white;
}

.valider .btn-valid {
  background-color: #9dc544;
  color: white;
}

.connect a {
  color: white;
}
.btn-connect{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.btn-connect:hover{
  color: black !important;
}
.btn-cancel{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.btn-cancel:hover{
  color: black !important;
}
.btn-refresh{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #6c757d;
}
.btn-refresh:hover{
  color: black !important;
}
</style>